<script>
  import { t } from '../../i18n/index.js';

  let { imageData, onUse, onDiscard } = $props();
</script>

<div class="dialog-overlay">
  <div class="dialog-content">
    <h3 class="text-xl font-bold mb-4">{t('restore.title')}</h3>
    <p class="text-gray-400 mb-4">{t('restore.message')}</p>
    <div class="mb-4 bg-gray-700 rounded-lg p-2">
      <img src={imageData} class="max-h-40 mx-auto rounded" alt={t('restore.imageAlt')} />
    </div>
    <div class="flex gap-3">
      <button
        onclick={onDiscard}
        class="flex-1 py-3 px-4 bg-gray-700 hover:bg-gray-600 rounded-xl font-medium transition-colors"
      >
        {t('restore.discard')}
      </button>
      <button
        onclick={onUse}
        class="flex-1 py-3 px-4 bg-blue-600 hover:bg-blue-500 rounded-xl font-bold transition-colors"
      >
        {t('restore.use')}
      </button>
    </div>
  </div>
</div>

<style>
  .dialog-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.8);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    padding: 1rem;
  }

  .dialog-content {
    background: #1f2937;
    border-radius: 1rem;
    padding: 2rem;
    max-width: 320px;
    width: 100%;
    text-align: center;
  }
</style>
